import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=d7c53f08&"
import script from "./InviteCard.vue?vue&type=script&lang=js&"
export * from "./InviteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports